import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import {
  getActiveRequestTickets,
  getActiveRequestTicketsActionState,
  getResidentAppSettings,
  LoadActiveRequestTickets,
  LoadActiveRequestTicketsHQ,
} from '../../+state';
import { ITicketResidentOverviewEdge, TicketingVersion } from '../../models';
import { ResolverCommonService } from './resolver-common.service';
import { filter, firstValueFrom, map, take } from 'rxjs';
import { Store } from '@ngrx/store';

export const RequestTicketsActiveResolver: ResolveFn<ITicketResidentOverviewEdge[]> = (
  route: ActivatedRouteSnapshot
) => {
  const common = inject(ResolverCommonService);
  const store = inject(Store);
  const { resolverWaitForData } = route.data;

  // Return the Promise chain from the resolver function
  return firstValueFrom(
    store.select(getResidentAppSettings).pipe(
      map(response => response?.ticketingVersion),
      filter(response => response !== null),
      take(1)
    )
  )
    .then(version => {
      return common.resolveHandler<ITicketResidentOverviewEdge[]>(
        getActiveRequestTicketsActionState,
        version === TicketingVersion.HIERARCHICAL
          ? LoadActiveRequestTicketsHQ({ offset: 0, limit: 20 })
          : LoadActiveRequestTickets({ offset: 0, limit: 20 }),
        getActiveRequestTickets,
        resolverWaitForData
      );
    })
    .catch(() => null);
};
